import { Route } from 'vue-router';
import { getPropsFromRoute } from '@/router/router-utils';
import Module, {
  IInitializerConfig,
  TInitEvents
} from './interfaces/module.interface';
import { ObjectToArray } from '@/utils';
import { RootState } from './types';
import { app } from '@/main';
import { modules } from './index';
import { IRouterProps } from '@/router/interfaces/router-props.interface';

const modulesArray = ObjectToArray<TStoreModule>(modules);

type TStoreModule = Module<any, RootState>;
class StoreInitializer {
  async emitEvent(event: TInitEvents, route?: Route) {
    const eventModules = this.getModulesByEvent(event);
    await this.execute(eventModules, route);
  }

  async execute(
    initializers: IInitializerConfig[],
    route: Route = app.$router.currentRoute
  ) {
    const props = getPropsFromRoute(route);

    for (const initializer of initializers) {
      if (!initializer.initialized) {
        try {
          await this.initializeStore(initializer, props, initializers);
          initializer.initialized = true;
        } catch (error) {
          initializer.initialized = false;
        }
      }
    }
  }

  private async initializeStore(
    initializer: IInitializerConfig,
    context: IRouterProps,
    initializers: IInitializerConfig[]
  ) {
    const { factory, requires } = initializer;

    if (requires) {
      for (const required of requires) {
        const requiredInit = initializers.find(
          initItem => initItem.provide === required
        );

        if (requiredInit && !requiredInit.initialized) {
          await this.initializeStore(requiredInit, context, initializers);
        }
      }
    }

    await factory(context);
  }

  private getModulesByEvent(event: TInitEvents) {
    return modulesArray
      .filter(module => module.initializer && module.initializer.on === event)
      .map(module => module.initializer) as IInitializerConfig[];
  }
}

export default new StoreInitializer();
